module.exports = __webpack_public_path__ + "img/img_slider01.e32fe673.png";